
import styled, { keyframes } from "styled-components";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  animation: ${rotate360} 1.4s linear infinite;
  transform: translateZ(0);

  border-top: 4px solid #c3c3c3;
  border-right: 4px solid #c3c3c3;
  border-bottom: 4px solid #c3c3c3;
  border-left: 4px solid #5093e1;
  background: transparent;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: auto;
`;


export const TinySpinner = styled.div`
  animation: ${rotate360} 1.4s linear infinite;
  transform: translateZ(0);

  border-top: 4px solid #ffff;
  border-right: 4px solid #ffff;
  border-bottom: 4px solid #ffff;
  border-left: 4px solid #5093e1;
  background: transparent;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: auto;
`;

export const TinySpinner2 = styled.div`
  animation: ${rotate360} 1.4s linear infinite;
  transform: translateZ(0);

  border-top: 4px solid #d3d3d3;
  border-right: 4px solid #5093e1;
  border-bottom: 4px solid #5093e1;
  border-left: 4px solid #5093e1;
  background: transparent;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: auto;
`;
